import { render } from "./InternetTos.vue?vue&type=template&id=6e7457ad"
import script from "./InternetTos.vue?vue&type=script&lang=js"
export * from "./InternetTos.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/INNCOM/INNCOM Project/2103.artemishosp.line.vue/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@4.47.0_supports-color@6.1.0_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__